/**
 * Zeus Loyalty — clipboard copy + Academy category filters.
 * Loaded defer by zeus-rewards, zeus-coupons, zeus-academy-grid sections.
 */
(function () {
  "use strict";

  // Emitted by every loyalty section; init only once per page (idempotent).
  if (window.__zeusLoyaltyInit) return;
  window.__zeusLoyaltyInit = true;

  function initCopyButtons(root) {
    var scope = root || document;
    var buttons = scope.querySelectorAll("[data-zeus-copy-btn]");
    if (!buttons.length) return;

    var feedback = scope.querySelector("[data-zeus-copy-feedback]");
    var copiedMsg = feedback ? (feedback.textContent || "").trim() : "";

    buttons.forEach(function (btn) {
      if (btn.dataset.zeusCopyBound) return;
      btn.dataset.zeusCopyBound = "true";

      var originalLabel = null;
      var resetTimer;

      btn.addEventListener("click", function () {
        var code = btn.getAttribute("data-code") || "";
        if (!code) return;

        function onCopied() {
          btn.setAttribute("aria-pressed", "true");
          if (originalLabel === null) originalLabel = btn.textContent;
          if (copiedMsg) btn.textContent = copiedMsg;
          if (feedback) {
            feedback.setAttribute("data-copied", "true");
            // Clear then re-set so the polite aria-live region actually announces.
            feedback.textContent = "";
            window.setTimeout(function () {
              feedback.textContent = copiedMsg;
            }, 80);
          }
          window.clearTimeout(resetTimer);
          resetTimer = window.setTimeout(function () {
            btn.removeAttribute("aria-pressed");
            if (originalLabel !== null) {
              btn.textContent = originalLabel;
              originalLabel = null;
            }
            if (feedback) feedback.removeAttribute("data-copied");
          }, 2500);
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard
            .writeText(code)
            .then(onCopied)
            .catch(function () {
              fallbackCopy(code, onCopied);
            });
        } else {
          fallbackCopy(code, onCopied);
        }
      });
    });
  }

  function fallbackCopy(text, callback) {
    var textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "absolute";
    textarea.style.left = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand("copy");
      if (callback) callback();
    } catch (e) {
      /* noop */
    }
    document.body.removeChild(textarea);
  }

  function initAcademyFilters(root) {
    var scope = root || document;
    var containers = scope.querySelectorAll("[data-zeus-academy-filters]");
    if (!containers.length) return;

    containers.forEach(function (container) {
      if (container.dataset.zeusFiltersBound) return;
      container.dataset.zeusFiltersBound = "true";

      var filterBtns = container.querySelectorAll("[data-zeus-filter]");
      var cards = container.querySelectorAll("[data-zeus-category]");
      if (!filterBtns.length) return;

      filterBtns.forEach(function (btn) {
        btn.addEventListener("click", function () {
          var filter = btn.getAttribute("data-zeus-filter");

          filterBtns.forEach(function (b) {
            var active = b === btn;
            b.classList.toggle("zeus-academy__filter-btn--active", active);
            b.setAttribute("aria-pressed", active ? "true" : "false");
          });

          cards.forEach(function (card) {
            var category = card.getAttribute("data-zeus-category");
            var show = filter === "all" || category === filter;
            card.hidden = !show;
          });

          var grids = container.querySelectorAll(".zeus-academy__grid");
          grids.forEach(function (grid) {
            var visible = grid.querySelectorAll("[data-zeus-category]:not([hidden])");
            var categoryTitle = grid.previousElementSibling;
            if (categoryTitle && categoryTitle.classList.contains("zeus-academy__category-title")) {
              categoryTitle.hidden = visible.length === 0 && filter !== "all";
            }
            if (filter !== "all") {
              grid.hidden = visible.length === 0;
            } else {
              grid.hidden = false;
            }
          });
        });
      });
    });
  }

  function init(scope) {
    initCopyButtons(scope);
    initAcademyFilters(scope);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
